/**
 * Escape the five characters that matter inside element content and attributes.
 *
 * The CRUD paints custom columns through [innerHTML], so any column rendering text a
 * person typed has to come through here. Shared rather than copied per formatter: this
 * is the kind of thing that gets fixed in one place and left wrong in the other two.
 *
 * Deliberately not round-tripping through a detached DOM element - that needs a
 * document, and these run from a table renderer that also executes during
 * server-side rendering.
 */
export function escapeHtml(value: string): string {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

/** The dash every optional column shows when there is nothing to show. */
export const EMPTY_CELL = '<span class="text-body-secondary">-</span>';
